
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uGame/check_in",
      function () {
        return require("private-next-pages/uGame/check_in.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uGame/check_in"])
      });
    }
  